import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Reverse Auth Guard
 * Prevents authenticated users from accessing certain routes (like signup, login)
 * Redirects authenticated users to dashboard
 */
export const reverseAuthGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Check if user has valid tokens (not just if they appear authenticated)
  if (authService.isAuthenticatedCheck()) {
    //console.log('ReverseAuthGuard: User has valid tokens, redirecting to dashboard');
    router.navigate(['/home']);
    return false;
  }

  // If user is not authenticated or tokens are invalid, allow access to the route
  //console.log('ReverseAuthGuard: User not authenticated or tokens invalid, allowing access');
  return true;
};
